"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _material = require("@mui/material");

var _Typography = require("../Typography");

var _jsxRuntime = require("react/jsx-runtime");

var StyledBox = (0, _material.styled)(_material.Box, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "background" && prop !== "fullWidth";
  }
})(function (_ref) {
  var theme = _ref.theme,
      background = _ref.background,
      fullWidth = _ref.fullWidth;
  return {
    alignItems: "center",
    background: background,
    border: background ? undefined : "1px solid #bbb",
    borderRadius: "4px",
    boxSizing: "border-box",
    display: "inline-flex",
    height: "1.25rem",
    justifyContent: "center",
    minWidth: "5rem",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    width: fullWidth ? "100%" : undefined
  };
});

var Sticker = function Sticker(_ref2) {
  var background = _ref2.background,
      _ref2$fullWidth = _ref2.fullWidth,
      fullWidth = _ref2$fullWidth === void 0 ? false : _ref2$fullWidth,
      children = _ref2.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledBox, {
    background: background,
    fullWidth: fullWidth,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.Typography, {
      color: "textPrimary",
      noWrap: true,
      sx: {
        color: background && "white",
        fontWeight: "bold",
        textTransform: "uppercase"
      },
      variant: "body3",
      children: children
    })
  });
};

var _default = Sticker;
exports.default = _default;